(function () {
  'use strict';

  function initCommunityVideo(root) {
    if (!root || root.dataset.cvInitialized === 'true') return;
    root.dataset.cvInitialized = 'true';

    const slider = root.querySelector('.community-video-slider');
    const prev = root.querySelector('.community-video-prev');
    const next = root.querySelector('.community-video-next');
    const cards = [...root.querySelectorAll('.community-video-card')];
    const videos = cards.map((card) => card.dataset.videoUrl || '').filter(Boolean);

    if (!slider || cards.length === 0) return;

    let currentIndex = 0;

    const modal = root.querySelector('.community-video-modal');
    const modalVideo = root.querySelector('.community-video-modal-video');

    function updateArrows() {
      if (!prev || !next) return;

      if (window.innerWidth <= 768) {
        prev.style.display = 'none';
        next.style.display = 'none';
        return;
      }

      prev.style.display = '';
      next.style.display = '';

      const maxScroll = slider.scrollWidth - slider.clientWidth;

      if (slider.scrollLeft <= 5) {
        prev.style.opacity = '0';
        prev.style.visibility = 'hidden';
      } else {
        prev.style.opacity = '0.7';
        prev.style.visibility = 'visible';
      }

      if (slider.scrollLeft >= maxScroll - 5) {
        next.style.opacity = '0';
        next.style.visibility = 'hidden';
      } else {
        next.style.opacity = '0.7';
        next.style.visibility = 'visible';
      }
    }

    updateArrows();
    slider.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    prev?.addEventListener('click', () => {
      slider.scrollBy({ left: -400, behavior: 'smooth' });
      setTimeout(updateArrows, 500);
    });

    next?.addEventListener('click', () => {
      slider.scrollBy({ left: 400, behavior: 'smooth' });
      setTimeout(updateArrows, 500);
    });

    function pausePreviewVideos() {
      root.querySelectorAll('.community-video-item').forEach((item) => {
        item.pause();
        const btn = item.closest('.community-video-card')?.querySelector('.community-video-play');
        if (btn) btn.style.opacity = '1';
      });
    }

    function openVideo(index) {
      if (!modal || !modalVideo || !videos[index]) return;

      pausePreviewVideos();
      currentIndex = index;
      modal.classList.add('active');
      modalVideo.src = videos[index];
      modalVideo.play();
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modal || !modalVideo) return;

      modal.classList.remove('active');
      modalVideo.pause();
      modalVideo.src = '';
      document.body.style.overflow = '';
    }

    function changeVideo(step) {
      if (!modalVideo || videos.length === 0) return;

      currentIndex += step;

      if (currentIndex < 0) currentIndex = videos.length - 1;
      if (currentIndex >= videos.length) currentIndex = 0;

      modalVideo.pause();
      modalVideo.src = videos[currentIndex];
      modalVideo.play();
    }

    cards.forEach((card) => {
      const index = Number(card.dataset.index);
      const playBtn = card.querySelector('.community-video-play');

      card.addEventListener('click', () => {
        openVideo(index);
      });

      playBtn?.addEventListener('click', (event) => {
        event.stopPropagation();
        openVideo(index);
      });
    });

    root.querySelector('.community-video-modal-prev')?.addEventListener('click', () => changeVideo(-1));
    root.querySelector('.community-video-modal-next')?.addEventListener('click', () => changeVideo(1));
    root.querySelector('.community-video-close')?.addEventListener('click', closeModal);
    root.querySelector('.community-video-overlay')?.addEventListener('click', closeModal);

    root._communityVideoKeydown = (event) => {
      if (event.key === 'Escape') closeModal();
      if (!modal?.classList.contains('active')) return;
      if (event.key === 'ArrowLeft') changeVideo(-1);
      if (event.key === 'ArrowRight') changeVideo(1);
    };

    document.addEventListener('keydown', root._communityVideoKeydown);
  }

  function observeCommunityVideo(root) {
    if (!root || root.dataset.cvObserved === 'true') return;
    root.dataset.cvObserved = 'true';

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              initCommunityVideo(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '200px 0px' }
      );

      observer.observe(root);
      return;
    }

    initCommunityVideo(root);
  }

  function initAllCommunityVideos(scope) {
    const container = scope || document;
    container.querySelectorAll('[data-community-video]').forEach(observeCommunityVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllCommunityVideos());
  } else {
    initAllCommunityVideos();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllCommunityVideos(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-community-video]').forEach((root) => {
      if (root._communityVideoKeydown) {
        document.removeEventListener('keydown', root._communityVideoKeydown);
      }
    });
  });
})();
